const links = [
	{
		path: '/academic/',
		home: true,
	},
	// {
	// 	path: '/academic/academic-centres/',
	// 	name: 'Центры исследований и экспертизы',
	// 	active: true,
	// },
	// {
	// 	path: '/academic/academic-faculty/',
	// 	name: 'Преподаватели',
	// 	active: true,
	// },
	{
		path: '/academic/academic-library/',
		name: 'Библиотека',
		active: true,
	},
	{
		path: '/academic/academic-team/',
		name: 'Команда',
		active: true,
	},
];

export default links;
